import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation';
import { Link } from 'src/@vex/interfaces/link.interface';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-nutri',
  templateUrl: './nutri.component.html',
  styleUrls: ['./nutri.component.scss'],
  animations: [
    scaleIn400ms,
    fadeInRight400ms
  ]
})
export class NutriComponent implements OnInit {
  links: Link[] = [
    {
      label: this.translate.instant('PROFILE_MENU.PROFILE'),
      route: './nutri-profile',
      routerLinkActiveOptions: { exact: true }
    },
    {
      label: 'password',
      route: './nutri-reset-password'
    }
  ];

  user

  constructor(public translate: TranslateService, public guiService: GuiService, public restService: RestService) { }

  ngOnInit(): void {
    setTimeout(()=>this.guiService.showSpinner = false,0)
    this.restService.getService('current_user', '').subscribe((ris)=>{
      this.user = ris
      console.debug(this.user)
      this.guiService.userLogged = ris;

    })
  }

}
